import React from 'react';
import { Redirect } from 'react-router';
import { Switch, Route } from 'react-router-dom';
import Account from '../SignupFlows/steps/Account';
import Call from '../SignupFlows/steps/Call';
import CPCall from '../SignupFlows/steps/CPCall';
import Start from './steps/Start';
import OutOfState from './steps/OutOfState';
import ThankYou from './steps/ThankYou';
import YourEmailScreen from './steps/YourEmail';
import QuestionnaireScreen from './steps/Questionnaire';
import End from './steps/End';
import Congratulations from './steps/Congratulations';
import DateAndStateScreen from './steps/DateAndState';
import WereAvailable from './components/Steps/WereAvailable';
import QuestionnaireStart from './steps/QuestionnaireStart';
import NotQualified from './steps/NotQualified';
import { DisclaimerScreen } from './steps/DisclaimerScreen';

export function TalkToUsRouter(props) {
  return (
    <Switch>
      {/* Talk to us normal flow */}
      <Route path="/talk-to-us" exact>
        <Start history={props.history} />
      </Route>

      <Route path="/talk-to-us/state" exact>
        <DateAndStateScreen
          history={props.history}
          availableRoute={'/talk-to-us/available'}
          unavailableRoute={'/talk-to-us/out-of-state'}
          prevRoute={'/talk-to-us'}
        />
      </Route>

      <Route path="/talk-to-us/available" exact>
        <WereAvailable
          history={props.history}
          prevRoute={'/talk-to-us/state'}
          nextRoute={'/talk-to-us/intro'}
        />
      </Route>

      <Route path="/talk-to-us/intro" exact>
        <QuestionnaireStart
          history={props.history}
          prevRoute={'/talk-to-us/available'}
          nextRoute={'/talk-to-us/details'}
        />
      </Route>

      <Route path="/talk-to-us/details" exact>
        <DisclaimerScreen
          history={props.history}
          prevRoute={'/talk-to-us/intro'}
          nextRoute={'/talk-to-us/email'}
        />
      </Route>

      <Route path="/talk-to-us/email" exact>
        <YourEmailScreen
          history={props.history}
          prevRoute={'/talk-to-us/details'}
          nextRoute={'/talk-to-us/questions'}
        />
      </Route>

      <Route path="/talk-to-us/questions" exact>
        <QuestionnaireScreen
          history={props.history}
          prevRoute={'/talk-to-us/email'}
          nextRoute={'/talk-to-us/schedule-call'}
          disqualifyingRoute={'/talk-to-us/disqualified'}
        />
      </Route>

      <Route path="/talk-to-us/schedule-call" exact>
        <End
          history={props.history}
          prevRoute={'/talk-to-us/questions'}
          nextRoute={'/talk-to-us/account'}
        />
      </Route>

      <Route path="/talk-to-us/account" exact>
        <Account
          step={2}
          numberOfSteps={4}
          redirectsToSchedule
          onDone={(account) => {
            if (account) {
              window.sessionStorage.setItem('account', JSON.stringify(account));
            }
            props.history.push('/talk-to-us/call');
          }}
        />
      </Route>

      <Route path="/talk-to-us/call" exact>
        <Call history={props.history} step={3} numberOfSteps={4} />
      </Route>

      {/* Alternate flows / service not available */}
      <Route path="/talk-to-us/thank-you" exact>
        <ThankYou />
      </Route>

      <Route path="/talk-to-us/out-of-state" exact>
        <OutOfState
          history={props.history}
          nextRoute={'/talk-to-us/thank-you'}
        />
      </Route>

      <Route path="/talk-to-us/disqualified" exact>
        <NotQualified history={props.history} />
      </Route>

      <Route path="/talk-to-us/congratulations" exact>
        <Congratulations history={props.history} />
      </Route>

      <Route path="/talk-to-us/reschedule" exact>
        <Call history={props.history} step={0} numberOfSteps={0} />
      </Route>

      <Route path="/talk-to-us/cp-call" exact>
        <CPCall step={3} numberOfSteps={4} />
      </Route>

      <Redirect to="/talk-to-us" />
    </Switch>
  );
}